import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
          {t('cta.title')}
        </h2>
        <p className="text-foreground-500 text-sm md:text-base max-w-md mx-auto mb-10">
          {t('cta.subtitle')}
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-10 py-4 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 transition-all"
        >
          {t('cta.button')}
          <i className="ri-arrow-right-line"></i>
        </a>

        <div className="mt-16 flex items-center justify-center gap-6 md:gap-12 flex-wrap">
          <div className="w-28 md:w-36 h-20 md:h-24 rounded-xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=A%20single%20retro%20running%20sneaker%20in%20cream%20and%20forest%20green%20colorway%20on%20a%20warm%20beige%20backdrop%2C%20clean%20product%20photography%2C%20soft%20studio%20lighting%2C%20elegant%20minimal%20composition&width=200&height=160&seq=cta-v2-01&orientation=landscape"
              alt="Scarpe running prodotto"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="w-28 md:w-36 h-20 md:h-24 rounded-xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=A%20oversized%20terracotta%20colored%20knit%20sweater%20neatly%20folded%20on%20a%20warm%20sand%20textured%20surface%2C%20clean%20minimalist%20product%20photography%2C%20soft%20natural%20light%20from%20left%2C%20cozy%20elevated%20aesthetic&width=200&height=160&seq=cta-v2-02&orientation=landscape"
              alt="Maglione prodotto"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="w-28 md:w-36 h-20 md:h-24 rounded-xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=A%20sleek%20black%20crossbody%20bag%20with%20gold%20hardware%20on%20a%20light%20oatmeal%20linen%20backdrop%2C%20luxury%20minimalist%20product%20photography%2C%20soft%20directional%20lighting%2C%20elegant%20composition%2C%20warm%20neutral%20tones&width=200&height=160&seq=cta-v2-03&orientation=landscape"
              alt="Borsa elegante prodotto"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="w-28 md:w-36 h-20 md:h-24 rounded-xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=A%20pair%20of%20tortoiseshell%20acetate%20sunglasses%20resting%20on%20a%20warm%20cream%20marble%20surface%2C%20premium%20minimalist%20product%20photography%2C%20soft%20window%20light%2C%20elegant%20lifestyle%20composition&width=200&height=160&seq=cta-v2-04&orientation=landscape"
              alt="Occhiali da sole prodotto"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="w-28 md:w-36 h-20 md:h-24 rounded-xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=A%20vintage%20inspired%20baseball%20cap%20in%20olive%20green%20on%20a%20warm%20textured%20paper%20backdrop%2C%20clean%20minimalist%20product%20photography%2C%20soft%20overhead%20lighting%2C%20simple%20elegant%20composition&width=200&height=160&seq=cta-v2-05&orientation=landscape"
              alt="Cappello prodotto"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}